import * as types from './action-types'

export const changePage = (page, headerStyle) => {
  return {
    type: types.CHANGE_PAGE,
    headerStyle: headerStyle,
    page: page
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/change-page.js